export default {
    title: '仪表盘',
    route: {
        index: '首页',
        account: '用户管理',
        role: '角色管理',
        group: '角色组管理',
        resource: '资源管理',
        app: '应用管理',
        data_type: '数据类型',
        laseholder: '租户管理',
        organizationvar: '组织机构',
        laseholderGroup: '租户组管理',
        UrlBlackWhite: 'URL黑白名单',
        userCenter: '个人中心',
        PostManage: '岗位管理'
    }
};